/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { Divider, Stack, styled } from '@mui/material';
import React, { FC } from 'react';

import SidebarLogoutButton from './SidebarLogoutButton';
import SidebarProfileAvatar from './SidebarProfileAvatar';
import SidebarProfileInfo from './SidebarProfileInfo';

const SidebarProfileRoot = styled(Stack, {
  name: 'SidebarProfile',
  slot: 'Root',
})(({ theme }) => ({
  padding: theme.spacing(0, 2),
  marginBottom: theme.spacing(2),
  color: theme.palette.dark[900],
  textAlign: 'left',
  justifyContent: 'space-between',
  borderRadius: 0,
}));

/**
 * Sidebar Profile
 */
const SidebarProfile: FC = () => {
  return (
    <>
      <Divider sx={{ mx: 2, mb: 1.5, borderColor: 'grey.200' }} />

      <SidebarProfileRoot direction="row" alignItems="center">
        <Stack direction="row" alignItems="center" spacing={1.3}>
          <SidebarProfileAvatar />
          <SidebarProfileInfo />
        </Stack>

        <SidebarLogoutButton />
      </SidebarProfileRoot>
    </>
  );
};

export default SidebarProfile;
